<div class="d-flex flex-column info-window">
  <div class="d-flex flex-column address-header">
    <div class="d-flex align-items-center">
      <span class="address m-0 flex-grow-1" [title]="propertyData | rlstAddress"><strong class="description-color">{{propertyData | rlstAddress | titlecase}}</strong></span>
      <span *ngIf="isHideWindowHookedUp()" class="hide-window" title="Hide Window" (click)="hideWindow.emit()"><span class="fa fa-minus"></span></span>
    </div>
    <div>
      <span class="city" [title]="propertyData | rlstStateZip"><strong class="description-color">{{propertyData | rlstStateZip}}</strong></span>
      <span class="star d-none d-md-inline-block pl-2" role="button" title="Follow/Unfollow this property" placement="bottom">
        <i class="fa text-orange"
           aria-hidden="true"
           [ngClass]="{'fa-star': isFavorite || isItemSaved(_propertyItem), 'fa-star-o': !isFavorite || !isItemSaved(_propertyItem)}"
           (click)="toggleSaved([_propertyItem, isFavorite])">
        </i>
        <span class="sr-only">Follow this property</span>
      </span>
    </div>
  </div>
  <div class="d-flex">
    <div style="width: 140px;">
      <img [src]="getPropertyPhotoUrlIfPresent()"
           (error)="hidePhoto()"
           [ngClass]="photoHidden ? 'd-none' : 'd-block h-100 w-100'"
           alt="property photo">
    </div>
    <div class="d-flex flex-column description">
      <span class="other" [title]="propertyData | rlstOwner"><strong
        class="description-color">Owner:</strong> {{propertyData | rlstOwner}}</span>
      <span class="other" style="white-space: pre;"><strong class="description-color">Tax ID:</strong> {{ _propertyItem?.propertyIdentifier?.apn }}</span>
      <span *ngIf="isPremiumSearchAvailable && selectedLayer" [title]="getPremAttribute()" class="other">
        <strong class="description-color">{{ selectedLayer?.label }}: </strong>
        {{ getPremAttribute() ? getPremAttribute() : 'N/A' }}
      </span>

      <span *ngIf="isPremiumSearchAvailable && getSellScoreValue() as value" [title]="value" class="other">
        <strong class="description-color">Sell Score:</strong>
        {{ value ? value : 'N/A' }}
      </span>
    </div>
  </div>
  <ul class="d-flex justify-content-around align-content-center info list-unstyled m-0">
    <li *ngFor="let summary of propertySummary" class="info-item">
      <span class="info-text d-block">{{summary.label}}</span>
      <span class="info-text d-block summary-info-text">{{summary.value}}</span>
    </li>
  </ul>
  <div class="d-flex btn-block">
    <div class="d-flex align-items-center btns" (click)="$event.stopPropagation()">
      <button class="d-block border-0 p-0 icon-btn"
              aria-label="Quick Zoom"
              data-tooltip-position="up-left"
              (click)="zoomInto()">
        <i class="far fa-search" aria-hidden="true"></i>
        <span class="sr-only">Search</span>
      </button>
      <button class="d-block border-0 p-0 icon-btn"
              aria-label="Parcel Dimensions"
              data-tooltip-position="above"
              (click)="getLotDimensions.emit()">
        <i class="far fa-ruler-combined" aria-hidden="true"></i>
        <span class="sr-only">Ruler</span>
      </button>
      <button *ngIf="propertyData.MLS_LISTING_NUMBER && isReverseLinkAvailable"
              class="d-block border-0 p-0 icon-btn"
              aria-label="Direct Link to MLS"
              data-tooltip-position="above"
              (click)="onReverseLinkClicked()">
        <i class="far fa-sign" aria-hidden="true"></i>
        <span class="sr-only">Sign</span>
      </button>
      <button *ngIf="hasPhotos"
              class="d-block border-0 p-0 icon-btn"
              aria-label="Property Photo"
              data-tooltip-position="above"
              (click)="onViewPhotoClick()">
        <i class="far fa-camera" aria-hidden="true"></i>
        <span class="sr-only">Photo</span>
      </button>
      <button class="d-block border-0 p-0 icon-btn instanet-link-icon"
              aria-label="Transaction Desk"
              data-tooltip-position="above"
              *ngIf="isInstanetLinkAvailable"
              (click)="instanetLink.emit()">
        <span class="sr-only">Transaction Desk</span>
      </button>

      <button class="d-block border-0 p-0 icon-btn"
              aria-label="Parcel Disclaimer"
              data-tooltip-position="above"
              (click)="loadParcelDisclaimer.emit(); $event.stopPropagation()">
        <img src="assets/img/disclaimer-icon.svg" alt="Parcel Disclaimer">
      </button>

    </div>
    <button class="close-info" (click)="openPropertyReport()">Report</button>
  </div>
</div>
